var $a240aba809e2b311$exports = {};
$a240aba809e2b311$exports = {
    "Empty": `Pr\xe1zdne`
};


export {$a240aba809e2b311$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
